import {webLinks} from '#/lib/constants'

export const DMCA_LINK = webLinks.copyright
